import { Colors } from '@oy/uicore';
import numeral from 'numeral';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCheckBridged, useEnv, useTranslate } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import { useSidebarState } from '../../hooks';

export const useBalanceSectionImpl = () => {
  const { isProdEnv } = useEnv();
  const { getTranslation } = useTranslate();
  const { isSidebarCollapsed } = useSidebarState();
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  const { showBridged } = useCheckBridged();

  const { showBalance, b2xUser } = useSelector(
    (state: RootState) => state.main,
  );
  const {
    balance = 0,
    pending_balance: pendingBalance = 0,
    freeze_balance: freezeBalance = 0,
    available_balance: availableBalance = 0,
    overdraft_balance: overdraftBalance = 0,
  } = b2xUser || {};

  const color = isProdEnv ? Colors.WHITE : Colors.BLACK100;
  const balanceDetails = [
    {
      value: numeral(balance).format('$0,0'),
      label: getTranslation('common_balance'),
      description: getTranslation('common_description_balance'),
    },
    {
      value: numeral(pendingBalance).format('$0,0'),
      label: getTranslation('common_pendingBalance'),
      description: getTranslation('common_description_pendingBalance'),
    },
    {
      value: numeral(freezeBalance).format('$0,0'),
      label: getTranslation('common_freezeBalance'),
      description:
        freezeBalance === 0
          ? getTranslation('common_freezeBalance_description_zero_case')
          : getTranslation('common_freezeBalance_description'),
    },
    {
      value: numeral(Math.floor(availableBalance)).format('$0,0'),
      label: getTranslation('common_availableBalance'),
      description: getTranslation(
        showBridged
          ? 'common_description_availableBalance'
          : 'common_description_availableBalanceWithoutBridged',
      ),
    },
  ];

  if (showBridged) {
    balanceDetails.splice(1, 0, {
      value: numeral(overdraftBalance).format('$0,0'),
      label: getTranslation('common_availableBridgedBalance'),
      description: getTranslation('common_description_availableBridgedBalance'),
    });
  }

  const toggleBalance = () => {
    dispatch({
      type: 'TOGGLE_SHOW_BALANCE',
      payload: { from: 'sidebar' },
    });
  };

  return {
    availableBalance,
    balanceDetails,
    color,
    isSidebarCollapsed,
    showBalance,
    showTooltip,
    setShowTooltip,
    toggleBalance,
  };
};
